const QRCodeIcon = () => {
    return (
        <svg
            width="15"
            height="14"
            viewBox="0 0 15 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_9566_6491)">
                <path
                    d="M6.82227 14H0.5V7.67773H6.82227V14ZM11.3389 14H9.75781V12.4189H11.3389V14ZM14.5 12.4189V14H12.9189V12.4189H14.5ZM1.85449 12.6455H5.46777V9.03223H1.85449V12.6455ZM9.75781 12.4189H8.17773V10.8389H9.75781V12.4189ZM12.9189 12.4189H11.3389V10.8389H12.9189V12.4189ZM11.3389 10.8389H9.75781V9.25781H11.3389V10.8389ZM14.5 10.8389H12.9189V9.25781H14.5V10.8389ZM9.75781 9.25781H8.17773V7.67773H9.75781V9.25781ZM12.9189 9.25781H11.3389V7.67773H12.9189V9.25781ZM6.82227 6.32227H0.5V0H6.82227V6.32227ZM14.5 6.32227H8.17773V0H14.5V6.32227ZM1.85449 4.96777H5.46777V1.35449H1.85449V4.96777ZM9.53223 4.96777H13.1455V1.35449H9.53223V4.96777Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_9566_6491">
                    <rect
                        width="14"
                        height="14"
                        fill="currentColor"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default QRCodeIcon;
